const actions = {
    FETCH_APPOINTED_TEACHERS: 'FETCH_APPOINTED_TEACHERS',
    FETCH_APPOINTED_TEACHER: 'FETCH_APPOINTED_TEACHER',
    RESET_APPOINTED_TEACHER: 'RESET_APPOINTED_TEACHER',

    fetchAppointedTeachersAction: (data) => {
        return {
            type: actions.FETCH_APPOINTED_TEACHERS,
            data: data
        };
    },

    resetAppointedTeacherFormAction: () => {
        return {
            type: actions.RESET_APPOINTED_TEACHER,
            data: null
        };
    },

    fetchAppointedTeacherAction: (data) => {
        return {
            type: actions.FETCH_APPOINTED_TEACHER,
            data: data
        };
    },
};

export default actions;
